import * as React from "react"
import i18n from "../../../i18n/i18n"
import { CertificateType } from "../../../models/flags/CertificateType"

interface IProps {
    certificateType: CertificateType
}

export default class IssuingAuthorityContactInfoComponent extends React.Component<IProps> {
    public render(): JSX.Element {
        const {
            certificateType = CertificateType.NotSet
        } = this.props

        return certificateType !== CertificateType.Adr ?
        /* Non Adr */
        (
            <div>
                <div className="row-fluid">
                    <p>{i18n.t("TEXT_PAYMENT_CARD_TYPES")}</p>
                    <img src={process.env.SERVER + "content/images/payment_types.png"} alt="Betalingstype logoer" />
                </div>
                <hr />
                <p>
                    Færdselsstyrelsen<br />
                    Sorsigvej 35<br />
                    6760 Ribe<br />
                    CVR: 40850031
                </p>
                <hr />
                <p>Du kan kontakte Færdselsstyrelsen på e-mail adresse <a href="mailto:bat@fstyr.dk">bat@fstyr.dk</a> eller telefonnr. 7221 8899.</p>
                <p>Du kan finde yderligere kontaktmulighed på <a href="http://www.fstyr.dk" target="new">Færdselsstyrelsens hjemmeside</a>.</p>
            </div>
        ) :
        /* Adr */
        (
            <div>
                <div className="row-fluid">
                    <p>{i18n.t("TEXT_PAYMENT_CARD_TYPES")}</p>
                    <img src={process.env.SERVER + "content/images/payment_types.png"} alt="Betalingstype logoer" />
                </div>
                <hr />
                <p>
                    Beredskabsstyrelsen<br />
                    Datavej 16<br />
                    3460 Birkerød<br />
                    CVR: 52990319
                </p>
                <hr />
                <p>Du kan kontakte Beredskabsstyrelsen på e-mail adresse <a href="mailto:brs-ktp-bfo-bfp-adr@brs.dk">brs-ktp-bfo-bfp-adr@brs.dk</a> eller telefonnr. 7285 2000.</p>
                <p>Du kan finde yderligere kontaktmulighed på <a href="https://brs.dk" target="new">Beredskabsstyrelsens hjemmeside</a>.</p>
            </div>
        )
    }
}